import _ from "lodash";
import React from "react";
import classes from "./AttachmentItem.scss";
import {
  getThumbUrl,
  getLabelValue,
  WORKBOOK_MODE_TYPES,
  htmlToText,
  onEnterOrSpaceKeyDown,
} from "Utils";
import { compose } from "lib/apolloClient";
import { connect } from "react-redux";
import classNames from "classnames";
import { DownloadIcon, CreateAssessmentSvg, Tick } from "SvgComponents";
import { colors } from "Constants";
import MediaModal from "UIComponents/MediaModal";
import I18nHOC from "UIComponents/I18nHOC";
import AudioRecorderSelector from "UIComponents/AudioRecorderSelector";
import { downloadFromUrl } from "modules/Services";
import ACLStore from "lib/aclStore";
import { IconButton, ProgressIndicator } from "@toddle-edu/ds-web";
import { DeleteOutlined } from "@toddle-edu/ds-icons";
import { getStudentResponseData } from "ClassRoom/modules/utils";
import { showNewTheatreMode } from "Utils/GetTheatreModeType";
import { getCurrentAssessmentTypes } from "Platform/modules/PlatformModule";
import { getIsAssessmentTypeConfigurationEnabled } from "Utils/ACLStoreUtils";
import {
  ASSIGNMENT_TYPE_QUICK_TASK,
  TASK_TYPE_QUICK_TASK,
} from "Constants/stringConstants";
export const ModelContent = ({
  attachments,
  toggleMediaModal,
  mode,
  sourceType,
  portalType,
  updateAttachments,
  activeIndex = 0,
  canDownloadMedia,
  testId,
  showEditResponseButtonProps,
  showPdfTronEditButton: showPdfTronEditButtonOverride,
  onEditAttachmentClick,
  allowedPermissions,
}) => {
  const showPdfTronEditButton =
    (mode === "edit" && sourceType === "STUDENT_TEMPLATE") ||
    showPdfTronEditButtonOverride;

  const workbookMode = _.isEqual(sourceType, "OPENING_MESSAGE_RESOURCE")
    ? WORKBOOK_MODE_TYPES["AI_TUTOR_RESOURCE"]
    : _.isEqual(sourceType, "STUDENT_TEMPLATE")
    ? WORKBOOK_MODE_TYPES["ADD_OR_EDIT_STUDENT_TEMPLATE"]
    : WORKBOOK_MODE_TYPES["USE_TEMPLATE"];
  return (
    <div className={classes.modalContent}>
      <MediaModal
        canDownloadMedia={canDownloadMedia}
        toggleMediaModal={toggleMediaModal}
        attachments={attachments}
        showWorkBook={
          mode == "edit" &&
          sourceType == "STUDENT_TEMPLATE" &&
          ACLStore.can("FeatureFlag:Workbook")
        }
        workbookMode={workbookMode}
        mode={mode}
        showPdfTronEditButton={showPdfTronEditButton}
        showPdfTronfeedback={true}
        updateAttachments={updateAttachments}
        activeIndex={showNewTheatreMode() ? activeIndex : 0}
        portalType={portalType}
        testId={testId}
        showEditResponseButtonProps={showEditResponseButtonProps}
        onEditAttachmentClick={onEditAttachmentClick}
        allowedPermissions={allowedPermissions}
        sourceType={sourceType}
      />
    </div>
  );
};

const PERMISSION_TYPE = {
  copy: "common:copy_for_student",
  edit: "common:drive_student_can_edit",
};

class AttachmentItem extends React.PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      showMediaModal: false,
    };
  }
  toggleMediaModal = value => {
    this.setState({ showMediaModal: false });
  };

  onClickAttachment = e => {
    const { showMediaModal } = this.state;
    e.stopPropagation();
    const {
      mode,
      attachment,
      onClickMedia,
      updateSelectedItems,
      isSelected,
      onClickAttachmentCard,
    } = this.props;

    if (onClickAttachmentCard) {
      onClickAttachmentCard(attachment.id, attachment);
    } else if (onClickMedia) {
      onClickMedia(attachment);
    } else {
      if (mode == "select") {
        updateSelectedItems({ attachment, isSelected });
      } else {
        if (!showMediaModal) {
          this.setState({ showMediaModal: true });
        }
      }
    }
  };

  onDeleteClick = e => {
    const {
      attachment: { id } = {},
      deleteAttachment,
      onDeleteAudioAttachment,
    } = this.props;
    if (onDeleteAudioAttachment) {
      onDeleteAudioAttachment();
      return;
    }
    e.stopPropagation();
    if (deleteAttachment) {
      deleteAttachment(id);
    }
  };

  onDownloadClick = e => {
    const { downloadFromUrl, attachment } = this.props;
    e.stopPropagation();
    downloadFromUrl({
      attachment: attachment,
      shouldAskForSave: true,
    });
  };

  getLabelValueForPost = ({ item, t }) => {
    const { title, name } = item;

    return title || name || t("common:untitled");
  };

  render() {
    const {
      customContainerStyle = {},
      attachment,
      mode,
      t,
      isSelected,
      showSingleCardTheme = true,
      updateAttachments,
      imageContainerStyle = {},
      detailContainerStyle = {},
      subText,
      disabled = false,
      deleteIconStyle = {},
      showDeleteButtonForNewUploads,
      showAudioDownloadButton = true,
      getCurrentAssessmentTypes,
      testId,
      isPrintEnabled = true,
      showWaveformPlayer = false,
    } = this.props;

    const currentAssessmentTypes = getCurrentAssessmentTypes();
    const { type, isPost, postEntityItems } = attachment;
    const { thumbUrl, isIcon, color, borderColor } = getThumbUrl({
      attachment: attachment,
      width: 256,
      height: 256,
    });

    const { showMediaModal } = this.state;
    const progressValue = parseInt(_.get(attachment, `progress`, "101"));

    //The progress Value is between 0-100 when its being uploaded, and once uploaded
    //the attachment doesn't have progress in it, so by default its 101, which means its created
    const isAttachmentCreated = progressValue > 100;

    const handleClick = e => {
      if (isAttachmentCreated) {
        this.onClickAttachment(e);
      }
    };

    if (attachment.type === "AUDIO") {
      return (
        <div
          className={classes.audioContainer}
          onClick={handleClick}
          data-test-id={`${testId}-audioRecorderSelector-div`}
          tabIndex={0}
          onKeyDown={e => onEnterOrSpaceKeyDown(e, handleClick)}
        >
          <AudioRecorderSelector
            mode={mode}
            value={attachment}
            onDeleteClick={this.onDeleteClick}
            showAudioDownloadButton={showAudioDownloadButton}
            testId={`${testId}-audioRecorderSelector`}
            showWaveform={showWaveformPlayer}
          />
          {mode == "select" && (
            <div className={classes.audioControlIconsCon}>
              {isSelected && (
                <Tick fill={colors.blue400} width={20} height={20} />
              )}
            </div>
          )}
        </div>
      );
    }

    let Icon = null;
    let iconColor = "";

    const { assessmentType, taskTypeGroup } = getStudentResponseData(
      postEntityItems
    );
    const isAssessmentTypeConfigurationEnabled = getIsAssessmentTypeConfigurationEnabled();
    if (assessmentType) {
      let iconType;
      if (isAssessmentTypeConfigurationEnabled) {
        iconType =
          taskTypeGroup === TASK_TYPE_QUICK_TASK ? "outlinedIcon" : "icon";
      } else {
        iconType =
          assessmentType === ASSIGNMENT_TYPE_QUICK_TASK
            ? "outlinedIcon"
            : "icon";
      }

      Icon =
        _.get(currentAssessmentTypes[assessmentType], iconType) ||
        CreateAssessmentSvg;
      iconColor = _.get(
        currentAssessmentTypes[assessmentType],
        "decorativeBGColor",
        colors.decorativeSurfaceOneL
      );
    }

    const nameTextClass = classNames(
      { [classes.nameText]: true },
      { [classes.singleCardThemeNameText]: showSingleCardTheme }
    );

    const typeTextClass = classNames(
      { [classes.typeText]: true },
      { [classes.singleCardThemeTypeText]: showSingleCardTheme }
    );

    const containerClass = classNames(
      { [classes.container]: true },
      { [classes.disabledContainer]: disabled }
    );

    const permission = _.get(attachment, "metadata.permission", false);
    const permissionText = _.get(PERMISSION_TYPE, permission, null);
    const { sourceType, portalType } = this.props;

    let attachmentImageContainerStyle = showSingleCardTheme
      ? {
          width: "46px",
          border: `1px solid ${borderColor}`,
          borderRadius: "4px",
        }
      : {};

    attachmentImageContainerStyle = {
      ...attachmentImageContainerStyle,
      border: "none",
      borderRight: "none",
    };

    const nameText = htmlToText(
      isPost
        ? this.getLabelValueForPost({ item: attachment, t })
        : getLabelValue({ item: attachment, t }),
      {
        wordwrap: 130,
        tags: {
          a: { options: { ignoreHref: true } },
          ul: { options: { itemPrefix: " " } },
        },
      }
    );

    return (
      <div
        className={containerClass}
        style={customContainerStyle}
        onClick={handleClick}
        data-test-id={`${testId}-attachment-div`}
        tabIndex={0}
        onKeyDown={e => onEnterOrSpaceKeyDown(e, handleClick)}
      >
        {assessmentType ? (
          <div
            className={classes.assessmentTypeIcon}
            style={{
              backgroundColor: iconColor,
            }}
          >
            <Icon
              size={"x-small"}
              variant={assessmentType === "qt" ? "link" : "default"}
            />
          </div>
        ) : (
          <div
            className={classes.attachmentImageContainer}
            style={{
              backgroundImage: `url(${thumbUrl})`,
              backgroundColor: color,
              backgroundSize: isIcon ? "35%" : "cover",
              ...attachmentImageContainerStyle,
              ...imageContainerStyle,
            }}
          >
            {progressValue < 100 && (
              <div className={classes.overlay}>
                <div className={classes.iconContainer}>
                  <ProgressIndicator
                    variant="preview-loader"
                    progress={progressValue}
                  ></ProgressIndicator>
                </div>
              </div>
            )}
          </div>
        )}
        <div
          className={classes.rightContainer}
          style={{
            padding: !showSingleCardTheme
              ? "8px 8px 8px 16px"
              : "0px 8px 0px 8px",
          }}
        >
          <div className={classes.detailContainer} style={detailContainerStyle}>
            <div className={nameTextClass}>{nameText}</div>
            <div className={typeTextClass}>
              {/* HACK: show type of permission based on sourceType === STUDENT_TEMPLATE, can be changed later */}
              {subText
                ? subText
                : permissionText
                ? t(permissionText)
                : sourceType === "STUDENT_TEMPLATE" && type === "IMAGE"
                ? t("common:copy_for_student")
                : type === "WORKBOOK" &&
                  _.get(attachment, "metadata.numOfPages", 0)
                ? t("common:workbook_page", {
                    count: _.get(attachment, "metadata.numOfPages", 0),
                  })
                : isPost
                ? "POST"
                : type}
            </div>
          </div>
          {mode == "select" && (
            <div className={classes.tickIconContainer}>
              {isSelected && (
                <Tick fill={colors.blue400} width={20} height={20} />
              )}
            </div>
          )}
          {mode == "edit" && isAttachmentCreated && (
            <div className={classes.deleteSvgIcon} style={deleteIconStyle}>
              <IconButton
                onClick={this.onDeleteClick}
                icon={<DeleteOutlined variant="subtle" />}
                _legacy_variant={"plain"}
                variant="neutral"
                type="plain"
                size={"medium"}
                testId={`${testId}-deleteOutlined`}
              />
            </div>
          )}
          {mode == "view" && isAttachmentCreated && type !== "WORKBOOK" && (
            <div className={classes.cardActionButtons}>
              {isPrintEnabled && (
                <IconButton
                  icon={<DownloadIcon variant="subtle" />}
                  _legacy_variant="plain"
                  variant="neutral"
                  type="plain"
                  size="medium"
                  onClick={this.onDownloadClick}
                  className={classes.downloadIconContainer}
                  testId={`${testId}-downloadContainer-div`}
                />
              )}
              {showDeleteButtonForNewUploads && (
                <div className={classes.deleteSvgIcon} style={deleteIconStyle}>
                  <IconButton
                    onClick={this.onDeleteClick}
                    icon={<DeleteOutlined variant="subtle" />}
                    _legacy_variant="plain"
                    variant="neutral"
                    type="plain"
                    testId={`${testId}-deleteOutlined`}
                    size={"medium"}
                  />
                </div>
              )}
            </div>
          )}
        </div>

        {showMediaModal && (
          <ModelContent
            attachments={[attachment]}
            toggleMediaModal={this.toggleMediaModal}
            mode={mode}
            sourceType={sourceType}
            portalType={portalType}
            updateAttachments={updateAttachments}
            testId={`${testId}-modalContent`}
            canDownloadMedia={isPrintEnabled}
            showEditResponseButtonProps={this.props.showEditResponseButton}
          />
        )}
      </div>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  const { attachment } = ownProps;
  const attachmentObj = {
    attachment: attachment.isPost
      ? {
          ..._.last(attachment.attachments),
          id: attachment.id,
          attachmentId: _.get(_.last(attachment.attachments), "id"),
          isPost: true,
          postEntityItems: _.get(attachment, "postEntityItems", []),
        }
      : attachment, //Handled attachment group
  };

  if (attachment.title) {
    return {
      attachment: { ...attachmentObj.attachment, title: attachment.title },
    };
  }
  return attachmentObj;
};

const mapActionCreators = { downloadFromUrl, getCurrentAssessmentTypes };

export default compose(
  I18nHOC({ resource: ["common"] }),
  connect(mapStateToProps, mapActionCreators)
)(AttachmentItem);
